module.exports = __webpack_public_path__ + "static/media/secure-login.6ad8c29a.svg";